import { createSelector } from 'reselect';

import { checkIsAuthenticated, embeddedViewRequested } from '../lib/helpers';

import type { AllowedUsers } from '@avalara/types/offers';
import type { State } from '@avalara/types/reducer-states';

export const offerStateSelector = (state: State) => state.offer;

const getAllowEmbeddedView = (state: State) => state.offer.allowEmbeddedView;

const checkIsEmbedded = (allowEmbeddedView?: boolean) => !!allowEmbeddedView && embeddedViewRequested();

export const isEmbeddedSelector = createSelector([getAllowEmbeddedView], checkIsEmbedded);

const getAllowedUsers = (state: State) => state.offer.allowedUsers;

const checkIsAuthenticationRequired = (allowEmbeddedView?: boolean, allowedUsers?: AllowedUsers) =>
  allowedUsers === 'EXISTING' || checkIsEmbedded(allowEmbeddedView);

export const isAuthenticationRequiredSelector = createSelector(
  [getAllowEmbeddedView, getAllowedUsers],
  checkIsAuthenticationRequired,
);

export const shouldRedirectToLogin = createSelector(
  [getAllowEmbeddedView, getAllowedUsers],
  (allowEmbeddedView, allowedUsers) =>
    checkIsAuthenticationRequired(allowEmbeddedView, allowedUsers) && !checkIsAuthenticated(),
);
